
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactMap from './components/ContactMap';
import ContactForm from './components/ContactForm';
import ContactCTA from './components/ContactCTA';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-neutral-900">
      <Navbar />
      <main>
        <ContactHero />
        <ContactInfo />
        <ContactMap />
        <ContactForm />
        <ContactCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
